<template>
  <div>
    <el-input-localized-numeric
      v-model="price"
      :disabled="disabled"
      size="small"
      @change="onUnitPriceChange"
    />
    <el-tag
      v-if="customPrice"
      type="info"
      size="small"
      style="margin-top: 5px;"
    >
      Egyedi ár
    </el-tag>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
      required: false,
    },
    customPrice: {
      type: Number,
      default() {
        return null;
      },
      required: false,
    },
    currency: {
      type: String,
      default() {
        return 'HUF';
      },
      required: false,
    },
    unitPrice: {
      type: Number,
      default() {
        return 0;
      },
      required: false,
    },
    minUnitPrice: {
      type: Number,
      default() {
        return 0;
      },
      required: false,
    },
  },
  data() {
    return {
      price: 0,
    };
  },
  watch: {
    unitPrice(price) {
      this.price = price;
    },
    customPrice(price) {
      this.price = price || this.unitPrice;
    },
  },
  mounted() {
    this.price = this.customPrice || this.unitPrice;
  },
  methods: {
    onUnitPriceChange(price) {
      this.price = price;
      this.$emit('change', this.price);
    },
  },
};
</script>
